const getters = {
    getPanel: state => state.panel.current,
}

export default getters
